export default __webpack_public_path__ + "static/media/token-aurora.84d9897c.png";